export function handleFileInput(callback?: (base64: string) => void) {
	return (event: React.ChangeEvent<HTMLInputElement>) => {
		const target = event.target;
		if (!target.files || !target.files[0]) {
			return;
		}
		const FR = new FileReader();
		FR.onload = (e) => {
			const base64String = e.target?.result as string;
			callback && callback(base64String);
		};
		FR.readAsDataURL(target.files[0]);
	};
}

export function handleMultipleFileInput(
	callback?: (base64s: string[]) => void
) {
	return (event: React.ChangeEvent<HTMLInputElement>) => {
		const target = event.target;
		if (!target.files) {
			return;
		}

		const files = target.files;
		const base64Strings: string[] = [];
		for (let i = 0; i < files.length; i++) {
			const file = files[i];
			const FR = new FileReader();
			FR.onload = (e) => {
				const base64String = e.target?.result as string;
				base64Strings.push(base64String);
			};
			FR.readAsDataURL(file);
		}
		setTimeout(() => callback && callback(base64Strings), 200);
	};
}
